var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_407_1092",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 60,
    height: 61
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.699219,
    width: 60,
    height: 60,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_407_1092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 40.6992H27.5V33.1992H35V28.1992H27.5V20.6992H22.5V28.1992H15V33.1992H22.5V40.6992ZM10 50.6992C8.625 50.6992 7.44792 50.2096 6.46875 49.2305C5.48958 48.2513 5 47.0742 5 45.6992V15.6992C5 14.3242 5.48958 13.1471 6.46875 12.168C7.44792 11.1888 8.625 10.6992 10 10.6992H40C41.375 10.6992 42.5521 11.1888 43.5312 12.168C44.5104 13.1471 45 14.3242 45 15.6992V26.9492L55 16.9492V44.4492L45 34.4492V45.6992C45 47.0742 44.5104 48.2513 43.5312 49.2305C42.5521 50.2096 41.375 50.6992 40 50.6992H10ZM10 45.6992H40V15.6992H10V45.6992Z",
    fill: "#4D4D4D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.27c8057c52906ba63e304cb7a08f07e4.svg";
export { ForwardRef as ReactComponent };